// Loading.js
import React from 'react';
import { ClipLoader } from 'react-spinners';

const Loading = () => (
  <div style={styles.spinnerContainer}>
    <ClipLoader size={50} color={"#123abc"} loading={true} />
  </div>
);

const styles = {
  spinnerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
  },
};

export default Loading;
